import { render, staticRenderFns } from "./PlacementsView.vue?vue&type=template&id=633cd6b1&scoped=true"
import script from "./PlacementsView.vue?vue&type=script&lang=js"
export * from "./PlacementsView.vue?vue&type=script&lang=js"
import style0 from "./PlacementsView.vue?vue&type=style&index=0&id=633cd6b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633cd6b1",
  null
  
)

export default component.exports